import createAsyncActionType from '../../../utilities/createAsyncActionType';

export const UPLOAD_SCORE_CARD = createAsyncActionType('UPLOAD_SCORE_CARD');

export const GET_LAST_SCORE_CARD = createAsyncActionType('getLastScoreCard');



// WEBPACK FOOTER //
// ./src/features/score-card/types/scoreCardTypes.js